




















































import BlockList, { loadBlockData } from '~/components/global/blocks/block-list'
import BlockWrapper from '~/components/global/blocks/block-wrapper'
import Accordion from '~/components/blocks/accordion'
import Marquee from '~/components/blocks/marquee'
import CardCarousel from '~/components/blocks/card-carousel'
import RegionSelector from '~/components/pages/flavor/region-selector'
import ScrapbookEntry from '~/components/blocks/scrapbook-entry'
import Stats from '~/components/pages/flavor/stats'
import pageMixin from '~/mixins/page-mixin'
import query from '~/queries/pages/flavor.gql'
import SoldOut from '~/components/global/cards/sold-out/sold-out'
import { buyNowConfig, findUsConfig } from '~/components/global/btn/buy-now'

export default
	name: 'Flavor'

	mixins: [ pageMixin ]

	components: {
		Accordion
		BlockWrapper
		BlockList
		CardCarousel
		Marquee
		RegionSelector
		ScrapbookEntry
		SoldOut
		Stats
	}

	# Title / SEO
	head: -> @buildHead
		description: @regionData.description
		image: @regionData.primaryImage

	asyncData: (context) ->
		{ app: {$axios, $craft, $notFound }, route, params, payload } = context

		# Get data
		{ entry: page, brands } = payload || await $craft.execute
			query: query
			variables: slug: params.flavor
		return $notFound() unless page

		# Hydrate some blocks with additional data so that it gets SSRed
		await loadBlockData context, page.blocks

		# Set the region to CA if in the list, else the first
		regions = makeRegionsList page.regionalContent
		region = if ca = regions.find ({ value }) -> value == 'ca'
		then ca.value else regions[0]?.value

		# Set data
		return { page, brands, region }

	mounted: -> @addProperHigh()

	computed:

		# Vuex
		productTypes: -> @$store.state.navigation.productTypes

		# Massage data into the format expected by the marquee
		marquee: ->
			layout: 'narrow'
			primaryImage: @regionalImageOrFallback 'primaryImage'
			mobileImage: @regionalImageOrFallback 'primaryImageMobile'
			tallTexture: @page.flavorMarqueeTexture
			copy: @marqueeCopy
			breadcrumbs: @breadcrumbs
			links: @links || []

		# Add flavor name to the
		marqueeCopy: -> "<h1>#{@page.title}</h1>#{@regionData.description || ''}"

		# Make breadcrumbs for the flavor
		breadcrumbs: -> @$nonEmpty [
			{ label: 'Products', href: '/products' }
			@brands.find (brand) => brand.slug == @page.brand?.slug
			@productTypes.find (type) => type.slug == @page.productType[0]?.slug
		]

		# Make the links, which change if the user supports buy now
		links: ->
			unless @inZoneBuyLink then [ @findUsLink ]
			else [ @inZoneBuyLink, @findUsLink ]

		# Return the in zone buy now url
		inZoneBuyLink: ->
			return unless @$store.state.buy.supported
			url = if @region == 'ma' and @page.maUrl then @page.maUrl else if @region == 'ny' and @page.nyUrl then @page.nyUrl else @page.buyNowUrl
			return unless url
			# return unless @$store.state.buy.supported and @page.buyNowUrl
			{ ...buyNowConfig, href: url }

		# Make the find us link config, which uses A Proper High if specified
		findUsLink: -> switch

			# A Proper High link
			when url = @page.properHighUrl then {
				...findUsConfig
				displayConditions: null
				href: url
			}

			# In zone with buy now
			when @inZoneBuyLink then findUsConfig

			# Just find us link
			else
				label: 'Where to buy'
				href: '/find-us'

		# Get the active region's data
		regionData: ->
			return {} unless @region # Default to an empty object
			@page.regionalContent.find ({ regions }) =>
				regions.find ({ slug }) => slug == @region

		# Make the accordion data
		details: ->
			panes = [
				@ingredientsPane
				@nutritionPane
				@additionalInformationPane
				...(@regionData.details || [])
			].filter (val) -> !!val
			return unless panes.length
			{ panes }

		# Make ingredients pane from dedicated field
		ingredientsPane: ->
			return unless @regionData.ingredients
			id: 'ingredients'
			label: 'Ingredients'
			accordionPaneBody: "<p>#{@regionData.ingredients}</p>"

		# Make nutrition table
		nutritionPane: ->
			return unless @regionData.nutrition?.length
			id: 'nutrition'
			label: 'Nutritional Information'
			accordionPaneDictionary: @regionData.nutrition

		# Additional information list
		additionalInformationPane: ->
			return unless @regionData.additionalInformation?.length
			id: 'additionalInformation'
			label: 'Product Information'
			accordionPaneBody: do =>
				html = '<ul>'
				for { listItem } in @regionData.additionalInformation
				then html += "<li>#{listItem}</li>"
				html += '</ul>'
				return html

		# Make the list of regions for the region selector
		regions: -> makeRegionsList @page.regionalContent

		# Use new stats table or fallback to legacy, specific fields
		stats: ->
			return @regionData.stats if @regionData.stats?.length
			[
				{ label: 'THC per serving', value: @regionData.thcPerServing }
				{ label: 'CBD per serving', value: @regionData.cbdPerServing }
				{ label: 'CBN per serving', value: @regionData.cbnPerServing }
				{ label: 'THC per pack', value: @regionData.thcPerPack }
				{ label: 'CBD per pack', value: @regionData.cbdPerPack }
				{ label: 'CBN per pack', value: @regionData.cbnPerPack }
				{ label: 'Effect', value: @regionData.effect }
			].filter (stat) -> !!stat.value

		# Show customer reviews
		customerReviews: -> @page.customerReviews || []

		# Format the brand flavors into the expected format
		brandFlavors: ->
			columns: 5
			imageAspectRatio: '650:560'
			cards: (@page.brand?.flavors || []).filter ({ id }) =>
				return id != @page.id # Don't show own flavor
			config: ['wrapAround', 'freeScroll']

		# The link to view all of this product type
		brandViewAll: -> "/products?brand=#{@page.brand.slug}"

		# Map the list of brands into block-like data for scrapbook entrys
		otherBrands: ->
			@brands.filter ({ slug }) => slug != @page.brand?.slug
			.map (brand, index) ->
				orientation: if index % 2 then 'textOnLeft' else 'textOnRight'
				copy: """
					<p class='eyebrow'>#{brand.title}</p>
					#{brand.description?.replace('p>', 'h3>') || ''}
				""" # Switch <p> to <h3>
				primaryImage: brand.brandListingImage
				texture: brand.brandListingTexture
				links: [
					buttonType: 'text'
					label: 'View All'
					href: "/#{brand.uri}"
				]

	methods:


		# Add the proper high JS
		addProperHigh: ->
			url = 'https://aph-uploads-production.s3.amazonaws.com/connect.js'
			@$loadScript url, async: true
			@initProperHigh()

		# Poll for proper high to be ready
		initProperHigh: ->
			if cb = window.createProperOverlay
			then cb() else @$wait 100, @initProperHigh

		# Return the regional image field or fallback to the first found
		regionalImageOrFallback: (field) ->
			if @regionData[field]?.length then @regionData[field]
			else @firstNonEmptyRegionalField field

		# Get the value of the specified field for the first regional data entry
		# that matches
		firstNonEmptyRegionalField: (field) ->
			if match = @page.regionalContent.find (content) =>
				if Array.isArray content[field]
				then content[field].length
				else !!content[field]
			then return match[field]


# Make a list of regions
makeRegionsList = (regionalContent) ->
	regionalContent.reduce (regions, data) ->
		for region in data.regions
			regions.push
				text: region.slug.toUpperCase()
				value: region.slug
		return regions
	, []

